import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';

const CustomInvite = (props) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);


    const [userType, setUserType] = useState('artlover');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }




    const checkButtonStatus = () => {
        console.log(userType, firstName, lastName, email)

        if (userType && firstName && lastName && email) {
            return false;
        }
        return true;
    }


    const onInvite = () => {

        console.log(userType, firstName, lastName, email)



        console.log("onInvite");
        if (firstName?.length > 0 && lastName?.length > 0 && email?.length > 0) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                userType: userType, firstName: firstName, lastName: lastName, email: email,
            };
            //TODO UN
            if (userType === 'artlover') {
                //    apiParams.verificationToken = verificationToken;
            }




            console.log("onInvite", apiParams);

            AuthenticationService.registerWithToken(apiParams,AuthService.getToken()).then(

                (response) => {
                    console.log("onInvite", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }


                        props.toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onRegister", response);

                        setDisplayLoadingDialog(false);
                        props?.setDialogVisible(false);


                        let _detail = t('global_text_invite_to_vault_success')

                        props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

        }


    }

    const renderAuthInfo = () => {
        return (
            <div className="col-12 md:col-12 flex justify-content-center  " >
                <div className="register-content w-12   p-3">
                    <div className="col-12 md:col-12" style={{
                        wordWrap: 'break-word',
                        paddingBottom: 5,
                    }}>
                        {t('global_text_invite_to_vault')}
                    </div>
                    <div className="col-12 md:col-12">
                        <div className="grid formgrid">
                            <div className="col-12 lg:col-3 mb-2">
                                <InputText id="firstname" value={firstName} onChange={(e) => setFirstName(e.target.value)} type="text"
                                    placeholder={t('global_text_firstname')} className="inputtext_raunded p-inputtext "

                                />
                            </div>

                            <div className="col-12  lg:col-3  mb-2">
                                <InputText id="lastname" value={lastName} onChange={(e) => setLastName(e.target.value)}
                                    type="text" placeholder={t('global_text_lastname')} className="inputtext_raunded p-inputtext "
                                />
                            </div>
                            <div className="col-12 lg:col-6  mb-2">
                                <InputText id="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off"
                                    className="inputtext_raunded p-inputtext " type="text" placeholder={t('global_text_email')}></InputText>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )

    }


    const renderButton = () => {

        return (
            <div className=" flex justify-content-center p-1 w-12">
                <div className=" w-fit ">
                    <Button label={t("global_text_invite")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                        onClick={() => onInvite()}

                    />
                </div>

            </div>
        )


    }
    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderAuthInfo()}

            {renderButton()}


        </div>
    )
}

export default CustomInvite;